import { render, staticRenderFns } from "./DatenschutzPage.vue?vue&type=template&id=daca3806&scoped=true"
import script from "./DatenschutzPage.vue?vue&type=script&lang=js"
export * from "./DatenschutzPage.vue?vue&type=script&lang=js"
import style0 from "./DatenschutzPage.vue?vue&type=style&index=0&id=daca3806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daca3806",
  null
  
)

export default component.exports